<template>
  <update-business-member-field
    title="Last Appointment Location"
    :value="capitalize(member.appointmentLocation)"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-select placeholder="Select a location" :options="appointmentLocationOptions" label-key="name" v-model="appointmentLocation" required />
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";
import { capitalize } from "lodash";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      appointmentLocation: "",
      appointmentLocationOptions: [{ value: "office", name: "In Office Visit" }, { value: "virtual", name: "Virtual Visit" }],
    };
  },
  methods: {
    capitalize,
    handleIsEditing($event) {
      this.appointmentLocation = this.member.appointmentLocation;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        appointmentLocation: this.appointmentLocation,
      });
    },
  },
};
</script>
